import React, { useState, useEffect } from 'react';

const DateSwitch = ({currentDay, setCurrentDay, switchInfos}) => {
  
  return (
    <div className="switch-container">
      {switchInfos.map((info, index) => {
        return (
          <div onClick={setCurrentDay.bind(this, index)} className={currentDay === index ? 'switch-item active' : 'switch-item'} key={index}>
            <div className="date-container">
              <div className="day">{info.day}</div>
              <div className="date">{info.date}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

const SpeakerItem = ({info}) => {
  return (
    <div className="speaker-item">
      <div className="speaker-img">
        <img className="pc-img" src={info.img}/>
        <img className="mobile-img" src={info.mobileImg} />
        <div className="speaker-name">
          <div className="text">{info.name}</div>
        </div>
      </div>
      <div className="desc-container">
        <div className="desc" dangerouslySetInnerHTML={{ __html: info.speakerDesc}}></div>
        <div className="quote">
          {/* <span className="label">Quote:</span> */}
          <span className="text">{info.speakerQuote}</span>
        </div>
      </div>
      
    </div>
  )
}

const Card = ({info}) => {
  
  return (
    <div className="card-item">
      <div className="team-container">
        <h2 className="team-title">{info.teamName}</h2>
        <span className="triangle left"></span>
        <span className="triangle right"></span>
      </div>
      {
        info.list ? info.list.map((item, key) => {
          return (
            <div className="detail-wrapper">
              <div className="session-container">
                {/* <h2 className="title">{info.sessionTitle}</h2> */}
                <div className="desc">{item.sessionDesc}</div>
              </div>
              <div className="speaker-container">
                <h2 className="title">{item.speakerTitle}</h2>
                <div className="items-container">
                  {
                    item.speakersInfo.map((speakers, index) => {
                      return <SpeakerItem info={speakers} key={index}/>
                    })
                  }
                </div>
              </div>
            </div>
          )
        }) : (
          <div>
            <div className="session-container">
              {/* <h2 className="title">{info.sessionTitle}</h2> */}
              <div className="desc">{info.sessionDesc}</div>
            </div>
            <div className="speaker-container">
              <h2 className="title">{info.speakerTitle}</h2>
              <div className="items-container">
                {
                  info.speakersInfo.map((speakers, index) => {
                    return <SpeakerItem info={speakers} key={index}/>
                  })
                }
              </div>
            </div>
          </div>
        )
      }
      
    </div>
  )
};

const Speaker = ({message}) => {
  const [currentDay, setCurrentDay] = useState(0);

  return (
    <section id="speakers">
      <h2 className="section-title">{message.title}</h2>
      <DateSwitch switchInfos={message.switchInfos} setCurrentDay={setCurrentDay} currentDay={currentDay}/>
      <div className="card-container">
        <div className={currentDay === 0 ? 'show' : 'hidden'}>
        {
          message.listMap[0].map((info, index) => {
            return <Card info={info} key={index}/>
          })
        }
        </div>
        <div className={currentDay === 1 ? 'show' : 'hidden'}>
        {
          message.listMap[1].map((info, index) => {
            return <Card info={info} key={index}/>
          })
        }
        </div>
      </div>
    </section>
  )
};

export default Speaker;